import {ContentfulCard} from '@github-ui/swp-core/components/contentful/ContentfulCard'
import type {PrimerCards} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerCards'
import {Section} from '@primer/react-brand/esm'

import styles from './Cards.module.css'

export type CardsProps = {
  component: PrimerCards
  className?: string
  hideGridline?: 'top' | 'bottom'
}

export function Cards({component, className, hideGridline}: CardsProps) {
  const items = component?.fields?.cards ?? []

  return (
    <Section
      as="div"
      variant="gridline"
      paddingBlockStart="none"
      paddingBlockEnd="none"
      data-padding-inline="0"
      data-hide-gridline={hideGridline ?? undefined}
    >
      <div className={`${styles.Cards} ${className}`} data-item-count={items.length}>
        {items.map(card => (
          <div key={card.sys.id} className={styles.Card}>
            <ContentfulCard component={card} fullWidth ctaVariant="arrow" />
          </div>
        ))}
      </div>
    </Section>
  )
}
